import { domReady } from '../modules/utils.js';

class CourseStickyCta extends HTMLElement {
  async connectedCallback() {
    await domReady();

    this.refs = {
      button: this.querySelector('.coursehero-sticky-button'),
      modal: this.querySelector('.coursehero-modal'),
      panel: this.querySelector('.coursehero-modal-panel'),
      backdrop: this.querySelector('.coursehero-modal-backdrop'),
      closeButton: this.querySelector('.coursehero-modal-close'),
    };

    this.#setListeners();
    this.#observeTarget();
  }

  disconnectedCallback() {
    this.#unsetListeners();
    this.observer?.disconnect();
  }

  #setListeners() {
    this.refs.button?.addEventListener('click', this.open);
    this.refs.closeButton?.addEventListener('click', this.close);
    this.refs.backdrop?.addEventListener('click', this.close);
    document.addEventListener('keydown', this.#onKeydown);
  }

  #unsetListeners() {
    this.refs.button?.removeEventListener('click', this.open);
    this.refs.closeButton?.removeEventListener('click', this.close);
    this.refs.backdrop?.removeEventListener('click', this.close);
    document.removeEventListener('keydown', this.#onKeydown);
  }

  // shows the sticky button once `data-observe`'s target (the course hero)
  // has fully scrolled out of view, and hides it again when it scrolls back
  #observeTarget() {
    const target = document.querySelector(this.dataset.observe);
    if (!target) return;

    this.observer = new IntersectionObserver(([entry]) => {
      this.toggleAttribute('data-visible', !entry.isIntersecting);
    });
    this.observer.observe(target);
  }

  #onKeydown = (event) => {
    if (event.key === 'Escape' && this.refs.modal?.hasAttribute('data-open')) {
      this.close();
    }
  };

  open = () => {
    if (this.refs.modal?.hasAttribute('data-open')) return;

    this.lastFocused = document.activeElement;
    this.refs.modal?.removeAttribute('inert');
    this.refs.modal?.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      this.refs.modal?.setAttribute('data-open', '');
    });

    this.refs.panel?.focus();
  };

  close = () => {
    if (!this.refs.modal?.hasAttribute('data-open')) return;

    this.refs.modal.removeAttribute('data-open');
    document.documentElement.style.overflow = '';

    const onTransitionEnd = (event) => {
      if (event.target !== this.refs.modal) return;
      this.refs.modal.removeEventListener('transitionend', onTransitionEnd);
      this.refs.modal.setAttribute('aria-hidden', 'true');
      this.refs.modal.setAttribute('inert', '');
    };
    this.refs.modal?.addEventListener('transitionend', onTransitionEnd);

    if (this.lastFocused instanceof HTMLElement) {
      this.lastFocused.focus();
    }
  };
}

customElements.define('course-sticky-cta', CourseStickyCta);
